//PageContainer.tsx
import { useMenu } from '@/common/_hooks/MenuContext'

type Props = {
  description?: string
  children: JSX.Element | JSX.Element[]
  title?: string | null
}

const PageContainer = ({ title, description, children }: Props) => {
  const { matchedMenu } = useMenu()
  const systemName = '유가보조금 포털시스템'
  const menuExpln = matchedMenu?.menuExpln ?? systemName
  return (
    <div>
      <title>{title ?? menuExpln}</title>
      <meta
        name="description"
        content={`유가보조금 사용자 포털 제공을 통해 대국민 서비스 제공 및 로그인 기반의 운수종사자 대상 개인화 서비스를 제공합니다.`}
      />
      {children}
    </div>
  )
}

export default PageContainer
